import { eu } from "../../../../date-fns/locale/eu.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    eu
  }
};